import * as ReselectModule from "reselect";
import { IWorkflowListState } from ".";
import { IApplicationState } from "..";

export const selectWorkflowList: ReselectModule.Selector<
  IApplicationState,
  IWorkflowListState
> = (state) => state.workflowList;
